export default __webpack_public_path__ + "static/media/positiveBankIndexRate.92b4a5f0.svg";